import { apiMiddleware } from 'redux-api-middleware'
import { routerMiddleware } from 'connected-react-router'
import callAPI from 'utils/callAPI'
import keyMirror from 'pkeymirror'
import queryString from 'query-string'
import _ from 'lodash'

// ------------------------------------
// Constants
// ------------------------------------
export const UTILITY_UTILITIES_PAYMENT = keyMirror({
  INIT_REQUEST: null,
  INIT_SUCCESS: null,
}, 'UTILITY_UTILITIES_PAYMENT')

// ------------------------------------
// Actions
// ------------------------------------
export function init() {
  return (dispatch) => {
    dispatch(
      callAPI({
        dispatch: dispatch,
        endpoint: '/cgs/api/lifecenter/v1/unauth/query-unities-service-provider',
        method: 'POST',
        body: {
          orderType: 'WATER_ELECTRIC'
        },
        requestAction: UTILITY_UTILITIES_PAYMENT.INIT_REQUEST,
        successAction: UTILITY_UTILITIES_PAYMENT.INIT_SUCCESS,
        success: function(result) {}
      })
    )
  }
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [UTILITY_UTILITIES_PAYMENT.INIT_REQUEST]: (state, action) => Object.assign({}, state, action.payload),
  [UTILITY_UTILITIES_PAYMENT.INIT_SUCCESS]: (state, action) => {
    const { serviceProviderList = [] } = action.payload
    const { serviceProvider } = queryString.parseUrl(window.location.href).query
    const serviceProviderInfo = _.find(serviceProviderList, (item) => item.serviceProviderCode === serviceProvider) || {}
    action.payload.serviceProviderName = serviceProviderInfo.serviceProviderName
    return Object.assign({}, state, action.payload)
  },
}

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {}
function reducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}

export default function(history) {
  return {
    id: 'utilityUtilitiesPayment',
    reducerMap: {
      utilityUtilitiesPaymentState: reducer
    },
    // middlewares when this module needed
    middlewares: [apiMiddleware, routerMiddleware(history)]
    // Actions to fire when this module is added/removed
    // initialActions: [],
    // finalActions: []
  }
}
